<nav id="content-navigation" class="content-navigation" [ngClass]="blockClasses" [attr.aria-label]="ariaLabel">
    <finder-picture *ngIf="logo" class="logo" [picture]="logo"></finder-picture>
    <finder-anchor *ngFor="let link of links"
        class="link-wrapper"
        [href]="link.href"
        [allowTracking]="true"
        [ariaCurrent]="link === activeLink$$() && ariaCurrent"
        [ariaLabel]="link.ariaLabel"
        (click)="handlePageAnchor($event, link)"
        >
        <div finderClickScrollTo scrollId="{{link.href}}" offsetElement="#content-navigation" class="link" [class.active]="link === activeLink$$()">
            <finder-polyline class="side-polyline" *ngIf="link.polylineLeft" [polyline]="link.polylineLeft" viewBox="none">
            </finder-polyline>
            <div class="link-inner">
                <div class="link-content">
                    <finder-font-icon
                        *ngIf="link.icon"
                        [svgSrc]="link.icon.src"
                        size="s"
                    >
                    </finder-font-icon>
                    <span class="link-label">{{link.title}}</span>
                </div>
                <finder-polyline *ngIf="link.polyline" [polyline]="link.polyline">
                </finder-polyline>
            </div>
            <finder-polyline class="side-polyline" *ngIf="link.polylineRight" [polyline]="link.polylineRight" viewBox="none">
            </finder-polyline>
        </div>
    </finder-anchor>
</nav>
